angular.module('bribac.components.optionalSampleOverview', [
  'pascalprecht.translate',
  'bribac.components.collapsingBox',
  'bribac.components.cardTestStatus',
  'bribac.components.testDetails'
])

  .component('optionalSampleOverview', {
    templateUrl: 'optional-sample-overview-component.html',
    bindings: {
      sample: '<',
        subject: '<',
      collapsed: '<',
      showTestType: '<'
    }
  })
